var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", { attrs: { fill: "#007D83", "fill-rule": "nonzero" } }, [
    _c("path", {
      attrs: {
        d: "M17.143 12c6 0 10 2.797 12.857 6.153l-4 2.516c-2-2.516-5.143-4.474-8.857-4.474-6.857 0-11.714 5.034-11.714 12.305 0 6.992 5.142 12.305 11.714 12.305 3.714 0 6.571-1.678 8.286-3.076v-5.593H14.857V27.66H30v11.746C26.857 42.763 22.286 45 16.857 45 7.714 45 0 38.568 0 28.5.286 18.432 7.714 12 17.143 12zM36 12h21v4.248H40.697v9.345h16.027v4.248H40.697V44H36V12z",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }